var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69",
    "data-name": "Group 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68.139,
    height: 73.411,
    viewBox: "0 0 68.139 73.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e142c0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 68.139,
    height: 73.41,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M68.139,44.553a14.93,14.93,0,0,0-6.826-12.319c0-.06.031-.113.031-.173v-7.5C61.344,11.025,49.11,0,34.115,0S6.872,11.025,6.872,24.559v7.5c0,.034.02.062.02.1A14.814,14.814,0,0,0,0,44.474C0,52.9,7.47,59.746,16.646,59.746a2.661,2.661,0,0,0,2.661-2.658V31.919a2.661,2.661,0,0,0-2.661-2.661,18.094,18.094,0,0,0-4.454.567V24.559c0-10.54,9.831-19.151,21.923-19.151s21.909,8.512,21.909,19.151V29.85a17.885,17.885,0,0,0-4.531-.593,2.674,2.674,0,0,0-2.661,2.571v25.26a2.661,2.661,0,0,0,2.661,2.658,18.148,18.148,0,0,0,4.117-.485,5.18,5.18,0,0,1-4.982,3.833h-6.65a7.253,7.253,0,0,0-6.716-4.511H32.007a7.278,7.278,0,0,0-7.28,7.249v.3a7.277,7.277,0,0,0,7.28,7.28h5.255a7.257,7.257,0,0,0,6.86-5h6.506A10.509,10.509,0,0,0,61.134,57.9v-.967a14.794,14.794,0,0,0,7.005-12.376m-54.151,9.6a10.331,10.331,0,0,1-8.645-9.675,10.35,10.35,0,0,1,8.645-9.709ZM37.261,68.094H32.052a1.958,1.958,0,0,1-1.961-1.963v-.3A1.958,1.958,0,0,1,32.052,63.9h5.209a1.927,1.927,0,0,1,1.909,1.779c0,.026-.014.045-.014.071,0,.079.04.148.045.224v.153a1.963,1.963,0,0,1-1.941,1.963m16.89-13.945V34.765A10.35,10.35,0,0,1,62.8,44.474a10.331,10.331,0,0,1-8.645,9.675",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistanceIcon);
export default __webpack_public_path__ + "static/media/Assistance_icon.49ebf843bf2f3bacf2cd548f62c95d01.svg";
export { ForwardRef as ReactComponent };